export const upsellingHc = {
  servicios: {
    accommodation: `Hébergement`,
    all: `Tous`,
    state: `Statut`,
    search: `Rechercher`,
    searchPlaceholder: `Voyageur ou code de réservation…`,
    from: `Du`,
    to: `Au`,
    today: `Aujourd'hui`,
    noDate: `Sans date`,
    clear: `Effacer`,
    thService: `Service`,
    thGuest: `Voyageur`,
    thBooking: `Réservation`,
    thRequested: `Demandé le`,
    statusConsult: `Sur demande`,
    statusRejected: `Refusé`,
    statusPaid: `Payé`,
    statusPartial: `Paiement partiel`,
    statusApproved: `Approuvé`,
    statusPending: `En attente`,
    serviceFallback: `Service`,
    openBookingTitle: `Ouvrir la réservation`,
    approve: `Approuver`,
    reject: `Refuser`,
    viewBooking: `Voir la réservation`,
    noRecords: `Aucun enregistrement`,
    noRecordsFiltered: `Aucun enregistrement trouvé avec les filtres appliqués.`,
    noRequestsYet: `Dès qu'un voyageur demandera un service, il apparaîtra ici.`,
    chipBreakfast: `Petit-déjeuner`,
    chipTour: `Excursion`,
    chipTransport: `Transport`,
    chipMore: `Et tout ce que vous proposez`,
    approveTitle: `Approuver la demande`,
    amountLabel: `Montant à facturer`,
    amountFree: `0 = sans frais`,
    amountHint: `Avec une passerelle de paiement connectée, le voyageur reçoit un <strong>lien de paiement</strong> (WhatsApp + e-mail). Sinon, il est informé qu'il <strong>paiera à son arrivée</strong>.`,
    cancel: `Annuler`,
    processing: `Traitement en cours…`,
    approveAndNotify: `Approuver et avertir`,
    amountInvalid: `Indiquez un montant valide (0 = sans frais).`,
    approvedPaymentLink: `Approuvée. Le lien de paiement a été envoyé au voyageur (WhatsApp + e-mail).`,
    approvedOnArrival: `Approuvée. Le voyageur paiera à son arrivée (aucune passerelle connectée).`,
    approvedNotified: `Approuvée. Le voyageur a été averti.`,
    approveFailed: `Impossible d'approuver la demande.`,
    rejectTitle: `Refuser la demande`,
    rejectMessage: `En la refusant, le voyageur ne sera PAS facturé pour ce service et en sera informé. Refuser la demande ?`,
    rejected: `Demande refusée. Le voyageur a été averti.`,
    rejectFailed: `Impossible de refuser la demande.`,
  },
  form: {
    basicTitle: `Informations de base`,
    basicDesc: `Le nom et la description que le voyageur verra.`,
    autoTranslate: `Rédigez-le dans <strong>votre langue</strong>. À l'enregistrement, il est traduit <strong>automatiquement</strong> dans toutes les langues (espagnol, anglais, portugais, français, allemand, italien, chinois et arabe) ; le voyageur verra la sienne.`,
    selectPlaceholder: `Sélectionner…`,
    catNightlife: `Vie nocturne`,
    subtitleLabel: `Sous-titre`,
    optional: `facultatif`,
    subtitlePlaceholder: `Une accroche courte, ex. : “Vivez l'expérience”`,
    price: `Prix`,
    priceDesc: `Comment ce service est facturé au voyageur.`,
    segWithPrice: `Avec prix`,
    segWithPriceDesc: `Facturé automatiquement`,
    segOnRequest: `Sur demande`,
    segOnRequestDesc: `Le voyageur demande, vous établissez le devis`,
    currencyLabel: `Devise`,
    currencyHint: `celle de l'annonce`,
    chargeBy: `Facturer par`,
    unitPlaceholder: `Choisissez le mode…`,
    unitPerUnit: `À l'unité (prix fixe)`,
    unitPerPerson: `Par personne (× voyageurs)`,
    unitPerNight: `Par nuit (× nuits)`,
    unitPerGroup: `Par groupe / séjour`,
    unitPerHour: `Par heure`,
    unitHintPerson: `Sera multiplié par le nombre de voyageurs de la réservation.`,
    unitHintNight: `Sera multiplié par le nombre de nuits de la réservation.`,
    unitHintUnit: `Prix fixe pour chaque unité achetée par le voyageur.`,
    unitHintGroup: `Prix unique pour la réservation, quel que soit le nombre de personnes ou de nuits.`,
    unitHintHour: `Prix par heure réservée.`,
    unitLabelPerson: `/ par personne`,
    unitLabelNight: `/ par nuit`,
    unitLabelGroup: `/ par séjour`,
    unitLabelHour: `/ par heure`,
    stockControl: `Contrôler le stock`,
    inventory: `inventaire`,
    stockDesc: `Pour ce qui s'épuise (ex. un lit ou un lit bébé supplémentaire) : limitez les unités. Elles sont décomptées automatiquement à chaque réservation et en temps réel.`,
    unitsAvailable: `Unités disponibles`,
    removeUnitAria: `Retirer une unité`,
    addUnitAria: `Ajouter une unité`,
    stockNoteSoldOut: `À <strong>0</strong> unité, le service apparaît <strong>Épuisé</strong> et ne peut pas être ajouté.`,
    stockNoteAuto: `En atteignant 0, <strong>Épuisé</strong> s'affichera automatiquement.`,
    stockConsumePerson: `Chaque réservation décompte 1 unité par voyageur.`,
    stockConsumeNight: `Chaque réservation décompte 1 unité par nuit.`,
    stockModeTitle: `Comment fonctionne le stock`,
    stockModeAvail: `Selon la disponibilité`,
    stockModeAvailDesc: `Occupé uniquement pendant le séjour et libéré au départ (lit bébé, lit supplémentaire).`,
    stockModeProduct: `Par produit`,
    stockModeProductDesc: `Décompté à chaque réservation et ne revient pas. Vous le réapprovisionnez manuellement.`,
    stockUnlimited: `Stock illimité — aucune limite d'unités.`,
    photosTitle: `Photos`,
    photoMain: `Principale`,
    makeMainTitle: `Définir comme principale`,
    removeTitle: `Retirer`,
    addPhoto: `Ajouter une photo`,
    addPhotos: `Ajouter des photos`,
    reorderHint: `Faites glisser pour réorganiser · la première est celle affichée sur la carte.`,
    whereTitle: `Où est-il proposé ?`,
    whereDesc: `Annonces où il sera disponible. Sans sélection = toutes.`,
    selected: `{count} sélectionnées`,
    all: `Toutes`,
    none: `Aucune`,
    searchListingPlaceholder: `Rechercher une annonce…`,
    noResults: `Aucun résultat`,
    diffCurrencyTitle: `Cette annonce utilise {currency}. Un service reste dans une seule devise.`,
    unit: `unité`,
    units: `unités`,
    loadingListings: `Chargement des annonces…`,
    previewLabel: `Aperçu · voici comment le voyageur le verra`,
    previewPhoto: `Votre photo principale`,
    previewTitleFallback: `Nom du service`,
    previewDescFallback: `La description que vous rédigez apparaîtra ici, afin que le voyageur sache ce qui est inclus.`,
    free: `Gratuit`,
    soldOut: `Épuisé`,
    add: `Ajouter`,
    remaining: `Il reste {count} unité | Il reste {count} unités`,
    scopeManaged: "Proposé dans <strong>toutes vos annonces</strong>. Choisissez lesquelles depuis la liste Services et expériences.",
    scopeAll: `Disponible dans <strong>tous vos hébergements</strong>`,
    scopeSome: `Disponible dans <strong>{count}</strong> annonce | Disponible dans <strong>{count}</strong> annonces`,
    errNameRequired: `Le nom est requis`,
    errCategoryRequired: `La catégorie est requise`,
    errDescRequired: `La description est requise`,
    errPriceRequired: `Saisissez un prix (mettez 0 si c'est gratuit).`,
    errPriceNegative: `Le prix ne peut pas être négatif.`,
    errUnitRequired: `Choisissez le mode de facturation (Facturer par)`,
    errStockRequired: `Indiquez combien d'unités sont en stock (mettez 0 si épuisé).`,
    errProcessing: `Erreur lors du traitement de la demande.`,
  },
  createServicio: {
    subtitle: `Remplissez les informations et regardez l'aperçu en temps réel.`,
    photosDesc: `Ajoutez-en autant que vous voulez · la 1re est la principale · JPG, PNG ou WebP.`,
    imageRequired: `Téléversez au moins une image.`,
  },
  updateServicio: {
    title: `Modifier l'expérience ou le service`,
    subtitle: `Mettez à jour les informations et regardez l'aperçu en temps réel.`,
    loadingAria: `Chargement du service`,
    photosDesc: `Ajoutez-en ou retirez-en autant que vous voulez · la 1re est la principale · JPG, PNG ou WebP.`,
    save: `Enregistrer les modifications`,
    imageRequired: `Au moins une image doit rester.`,
    loadFailed: `Impossible de charger le service.`,
  },
  configUpselling: {
    title: `Configuration des ventes croisées`,
    phoneIntro: `Saisissez le numéro de téléphone que vous souhaitez utiliser pour recevoir les notifications de demandes de service via WhatsApp`,
    saveWhatsapp: `Enregistrer WhatsApp`,
    editWhatsapp: `Modifier WhatsApp`,
    mustEnterWhatsapp: `Vous devez saisir le WhatsApp`,
    swalTitle: `WhatsApp des ventes croisées`,
    swalText: `Vous recevrez toutes les notifications des services demandés par les clients`,
    cancel: `Annuler`,
    addedSuccess: `WhatsApp ajouté avec succès`,
  },
};
